import React from 'react';
import styled from 'styled-components';
import { themeGet } from 'styled-system';
import { Link as RouterLink } from 'react-router-dom';
import { Box } from '../Layout';
import BackgroundImage from '../BackgroundImage';

const WrapperLink = styled(RouterLink)`
  display: block;
  transition: all 0.25s linear;

  &:hover {
    transform: scale(1.02);
  }
`;

const OverflowHidden = styled(Box)`
  overflow: hidden;
  position: relative;
`;

const TextOverlay = styled(Box)`
  color: white;
  position: absolute;
  bottom: 20px;
  left: 20px;
  font-size: ${themeGet('fontSizes.xl')};
  text-transform: uppercase;
  max-width: 50%;
`;

const ImageBox = ({ src, tag, link, height }) => (
  <OverflowHidden>
    <WrapperLink to={link}>
      <BackgroundImage src={src} height={height} width="100%" />
      <TextOverlay>{tag}</TextOverlay>
    </WrapperLink>
  </OverflowHidden>
);

export default ImageBox;



// WEBPACK FOOTER //
// ./src/ImageBox/ImageBox.js